<template>
  <div v-if="state === SwitchState.Mixed" class="mixed-switch" @click.stop="handleResolve">
    <IconWrapper name="mixSwitchIcon" />
  </div>
  <Switch
    v-else :color="color" :state="state === SwitchState.On" :disabled="disabled"
    @toggle="handleToggle"
  />
</template>

<script setup lang="ts">
import { SwitchColors, SwitchState } from '@/interfaces'
import { IconWrapper, Switch } from '@/components/common'

interface Props {
  state: SwitchState
  color?: SwitchColors
  disabled?: boolean
}

withDefaults(defineProps<Props>(), {
  color: SwitchColors.Blue,
  disabled: false,
})

const emit = defineEmits<{
  (e: 'toggle'): void
  (e: 'resolve'): void
}>()

const handleToggle = () => {
  emit('toggle')
}

const handleResolve = () => {
  emit('resolve')
}
</script>

<style lang="scss" scoped>
.mixed-switch {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 1rem;
  cursor: pointer;
  user-select: none;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 0.6;
  }
}
</style>
